'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$002489 from "./presto.types$$anon$89.js";
import * as $j_presto$002etypes$0024$002dRule from "./presto.types$-Rule.js";
import * as $j_presto$002etypes$0024$002dRule$0024$0024anon$0024102 from "./presto.types$-Rule$$anon$102.js";
import * as $j_presto$002etypes$0024$002dRule$0024$0024anon$002490 from "./presto.types$-Rule$$anon$90.js";
import * as $j_presto$002etypes$0024$002dRule$0024$0024anon$002492 from "./presto.types$-Rule$$anon$92.js";
import * as $j_presto$002etypes$0024$002dRule$0024$0024anon$002494 from "./presto.types$-Rule$$anon$94.js";
import * as $j_presto$002etypes$0024$002dRule$002dKind$0024 from "./presto.types$-Rule-Kind$.js";
var $p;
function $p_Lpresto_types$Rule$__decode$1__Lio_circe_HCursor__Lpresto_types$RuleKind__s_util_Either($thiz, c$1, kind) {
  var x = $j_presto$002etypes$0024$002dRule$002dKind$0024.$s_Lpresto_types$RuleKind$__Allow__Lpresto_types$RuleKind();
  if ((x === kind)) {
    return $thiz.cHK().F(c$1);
  }
  var x$3 = $j_presto$002etypes$0024$002dRule$002dKind$0024.$s_Lpresto_types$RuleKind$__Ip__Lpresto_types$RuleKind();
  if ((x$3 === kind)) {
    return $thiz.cHR().F(c$1);
  }
  var x$5 = $j_presto$002etypes$0024$002dRule$002dKind$0024.$s_Lpresto_types$RuleKind$__TimeRange__Lpresto_types$RuleKind();
  if ((x$5 === kind)) {
    return $thiz.cHX().F(c$1);
  }
  var x$7 = $j_presto$002etypes$0024$002dRule$002dKind$0024.$s_Lpresto_types$RuleKind$__DaysInWeek__Lpresto_types$RuleKind();
  if ((x$7 === kind)) {
    return $thiz.cHZ().F(c$1);
  }
  throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(kind);
}
export { $p_Lpresto_types$Rule$__decode$1__Lio_circe_HCursor__Lpresto_types$RuleKind__s_util_Either as $p_Lpresto_types$Rule$__decode$1__Lio_circe_HCursor__Lpresto_types$RuleKind__s_util_Either };
/** @constructor */
function $c_Lpresto_types$Rule$() {
  this.c9l = null;
  this.c9o = false;
  this.c9h = null;
  this.c9i = false;
  this.c9j = null;
  this.c9k = false;
  this.c9p = null;
  this.c9q = false;
  this.c9r = null;
  this.c9s = false;
  this.c9m = null;
  this.c9n = false;
}
export { $c_Lpresto_types$Rule$ as $c_Lpresto_types$Rule$ };
$p = $c_Lpresto_types$Rule$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Rule$;
/** @constructor */
function $h_Lpresto_types$Rule$() {
}
export { $h_Lpresto_types$Rule$ as $h_Lpresto_types$Rule$ };
$h_Lpresto_types$Rule$.prototype = $p;
$p.p5 = (function() {
  if ((!this.c9o)) {
    this.c9l = new $c_Lpresto_types$Rule$$anon$88(this);
    this.c9o = true;
  }
  return this.c9l;
});
$p.cHK = (function() {
  if ((!this.c9i)) {
    this.c9h = new $j_presto$002etypes$0024$002dRule$0024$0024anon$002490.$c_Lpresto_types$Rule$$anon$90(this);
    this.c9i = true;
  }
  return this.c9h;
});
$p.cHR = (function() {
  if ((!this.c9k)) {
    this.c9j = new $j_presto$002etypes$0024$002dRule$0024$0024anon$002492.$c_Lpresto_types$Rule$$anon$92(this);
    this.c9k = true;
  }
  return this.c9j;
});
$p.cHX = (function() {
  if ((!this.c9q)) {
    this.c9p = new $j_presto$002etypes$0024$002dRule$0024$0024anon$002494.$c_Lpresto_types$Rule$$anon$94(this);
    this.c9q = true;
  }
  return this.c9p;
});
$p.cHZ = (function() {
  if ((!this.c9s)) {
    this.c9r = new $j_presto$002etypes$0024$002dRule$0024$0024anon$0024102.$c_Lpresto_types$Rule$$anon$102(this);
    this.c9s = true;
  }
  return this.c9r;
});
$p.cHT = (function() {
  if ((!this.c9n)) {
    this.c9m = new $c_Lpresto_types$Rule$$anon$104(this);
    this.c9n = true;
  }
  return this.c9m;
});
$p.cGD = (function(x$0) {
  return new $j_presto$002etypes$0024$002dRule.$c_Lpresto_types$Rule($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uJ(x$0.j(0)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uJ(x$0.j(1)), x$0.j(2), x$0.j(3), x$0.j(4), x$0.j(5), x$0.j(6));
});
var $d_Lpresto_types$Rule$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Rule$, "presto.types$Rule$", ({
  a18: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$Rule$ as $d_Lpresto_types$Rule$ };
var $n_Lpresto_types$Rule$;
function $m_Lpresto_types$Rule$() {
  if ((!$n_Lpresto_types$Rule$)) {
    $n_Lpresto_types$Rule$ = new $c_Lpresto_types$Rule$();
  }
  return $n_Lpresto_types$Rule$;
}
export { $m_Lpresto_types$Rule$ as $m_Lpresto_types$Rule$ };
/** @constructor */
function $c_Lpresto_types$Rule$$anon$104(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$Rule$$anon$104 as $c_Lpresto_types$Rule$$anon$104 };
$p = $c_Lpresto_types$Rule$$anon$104.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Rule$$anon$104;
/** @constructor */
function $h_Lpresto_types$Rule$$anon$104() {
}
export { $h_Lpresto_types$Rule$$anon$104 as $h_Lpresto_types$Rule$$anon$104 };
$h_Lpresto_types$Rule$$anon$104.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.G = (function(c) {
  var this$1 = $m_Lpresto_types$Rule$();
  var this$2 = c.cHh("kind", $j_presto$002etypes$0024$002dRule$002dKind$0024.$m_Lpresto_types$RuleKind$().SS());
  if ((this$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Right)) {
    var b = this$2.bU;
    var this$3 = $p_Lpresto_types$Rule$__decode$1__Lio_circe_HCursor__Lpresto_types$RuleKind__s_util_Either(this$1, c, b);
    return ((this$3 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Right) ? new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Right(this$3.bU) : this$3);
  } else {
    return this$2;
  }
});
var $d_Lpresto_types$Rule$$anon$104 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Rule$$anon$104, "presto.types$Rule$$anon$104", ({
  a1a: 1,
  a: 1,
  f: 1
}));
export { $d_Lpresto_types$Rule$$anon$104 as $d_Lpresto_types$Rule$$anon$104 };
/** @constructor */
function $c_Lpresto_types$Rule$$anon$88(outer) {
  this.c9P = null;
  this.c9H = null;
  this.c9I = false;
  this.c9Q = null;
  this.c9R = false;
  this.c9U = null;
  this.c9N = null;
  this.c9O = false;
  this.c9J = null;
  this.c9K = false;
  this.c9L = null;
  this.c9M = false;
  this.c9S = false;
  this.c9T = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.c9P = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.c9U = "Rule";
}
export { $c_Lpresto_types$Rule$$anon$88 as $c_Lpresto_types$Rule$$anon$88 };
$p = $c_Lpresto_types$Rule$$anon$88.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Rule$$anon$88;
/** @constructor */
function $h_Lpresto_types$Rule$$anon$88() {
}
export { $h_Lpresto_types$Rule$$anon$88 as $h_Lpresto_types$Rule$$anon$88 };
$h_Lpresto_types$Rule$$anon$88.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.c9P;
});
$p.L = (function() {
  if ((!this.c9I)) {
    this.c9H = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.c9I = true;
  }
  return this.c9H;
});
$p.O = (function() {
  if ((!this.c9R)) {
    this.c9Q = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.c9R = true;
  }
  return this.c9Q;
});
$p.E = (function() {
  return this.c9U;
});
$p.t = (function() {
  if ((!this.c9O)) {
    this.c9N = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("account", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("deleted", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("description", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("payload", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))))));
    this.c9O = true;
  }
  return this.c9N;
});
$p.M = (function() {
  if ((!this.c9K)) {
    this.c9J = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().dZ, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().dZ, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($m_Lpresto_types$Rule$().cHT(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))))));
    this.c9K = true;
  }
  return this.c9J;
});
$p.Q = (function() {
  if ((!this.c9M)) {
    this.c9L = new $j_presto$002etypes$0024$0024anon$002489.$c_Lpresto_types$$anon$89();
    this.c9M = true;
  }
  return this.c9L;
});
$p.w = (function() {
  if ((!this.c9T)) {
    this.c9S = false;
    this.c9T = true;
  }
  return this.c9S;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee82) => ((p) => \u03b4scrutinee82.cGD(p)))($m_Lpresto_types$Rule$())));
});
var $d_Lpresto_types$Rule$$anon$88 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Rule$$anon$88, "presto.types$Rule$$anon$88", ({
  a1b: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$Rule$$anon$88 as $d_Lpresto_types$Rule$$anon$88 };
//# sourceMappingURL=presto.types$-Rule$.js.map
